import React from 'react';

const Title =()=>{
     /*Title component added*/
    return(<div>
     <h1 className ='title'>Alisina's Music-Box</h1>
          </div>)
}

export default Title;
